import React from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableRow,
	TableHead,
	Typography,
} from "@mui/material";

const compactTableCellStyle = {
	fontFamily: "Roboto Condensed",
	fontSize: "0.75rem",
	padding: "6px 8px",
	lineHeight: "1.2",
};

const headerCellStyle = {
	...compactTableCellStyle,
	fontWeight: "bold",
	backgroundColor: "#f5f5f5",
};

const ImportTable = ({ data, title, isReferenceMode = false, customCaptions = {} }) => {
	
	if (data.length === 0) {
		return null;
	} else {
		return (
			<div style={{ marginTop: 12 }}>
				<Typography variant="subtitle1" style={{ fontFamily: "Roboto Condensed", fontSize: "1rem", marginBottom: 8 }}>
					{title}
				</Typography>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell style={headerCellStyle}>{customCaptions?.assetSingular || "Asset"} Name</TableCell>
							{isReferenceMode ? (
								<>
									<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
										{customCaptions?.assetReferenceSingular || "Reference"} Name
									</TableCell>
									<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
										{customCaptions?.assetReferenceSingular || "Reference"} Description
									</TableCell>
									<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
										Planner Group
									</TableCell>
									<TableCell style={{ ...headerCellStyle, whiteSpace: "nowrap" }}>
										Work Center
									</TableCell>
								</>
							) : (
								<TableCell style={headerCellStyle}>{customCaptions?.assetSingular || "Asset"} Description</TableCell>
							)}
						</TableRow>
					</TableHead>
					<TableBody>
						{data.map((x, i) => {
							console.log('DEBUG - ImportTable row:', { i, x, isReferenceMode, assetDescription: x.assetDescription });
							return (
								<TableRow key={i}>
									<TableCell style={compactTableCellStyle}>{x.assetName}</TableCell>
									{isReferenceMode ? (
										<>
											<TableCell style={compactTableCellStyle}>{x.referenceName}</TableCell>
											<TableCell style={compactTableCellStyle}>{x.referenceDescription}</TableCell>
											<TableCell style={compactTableCellStyle}>{x.referencePlannerGroup}</TableCell>
											<TableCell style={compactTableCellStyle}>{x.referenceWorkCenter}</TableCell>
										</>
									) : (
										<TableCell style={compactTableCellStyle}>{x.assetDescription}</TableCell>
									)}
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</div>
		);
	}
};

export default ImportTable;
